/**
 * Parse le contenu HTML et retourne les éléments utiles
 * @param {string} htmlContent - Le contenu HTML
 * @returns {object} - Objet contenant tempDiv, firstP, firstDiv, et parts
 */
const parseHtmlContent = (htmlContent) => {
	if (!htmlContent) return null;
	
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = htmlContent;
	
	const firstP = tempDiv.querySelector('p');
	const firstDiv = tempDiv.querySelector('div');
	const parts = htmlContent.split('<br>');
	
	return { tempDiv, firstP, firstDiv, parts };
};

/**
 * Extrait le premier paragraphe d'un contenu HTML
 * @param {string} htmlContent - Le contenu HTML à traiter
 * @returns {string} - Le premier paragraphe en HTML
 */
export const getFirstParagraph = (htmlContent) => {
	const parsed = parseHtmlContent(htmlContent);
	if (!parsed) return '';
	
	const { firstP, firstDiv, parts } = parsed;
	
	if (firstP) {
		return firstP.innerHTML;
	}
	
	if (firstDiv) {
		return firstDiv.innerHTML;
	}
	
	return parts[0];
};

/**
 * Extrait tout le contenu sauf le premier paragraphe
 * @param {string} htmlContent - Le contenu HTML à traiter
 * @returns {string} - Le reste du contenu en HTML
 */
export const getRemainingContent = (htmlContent) => {
	const parsed = parseHtmlContent(htmlContent);
	if (!parsed) return '';
	
	const { tempDiv, firstP, firstDiv, parts } = parsed;
	
	if (firstP) {
		firstP.remove();
		return tempDiv.innerHTML;
	}
	
	if (firstDiv) {
		firstDiv.remove();
		return tempDiv.innerHTML;
	}
	
	if (parts.length > 1) {
		return parts.slice(1).join('<br>');
	}
	
	return '';
};

/**
 * Vérifie s'il y a du contenu restant après le premier paragraphe
 * @param {string} htmlContent - Le contenu HTML à traiter
 * @returns {boolean} - true s'il y a du contenu restant, false sinon
 */
export const hasRemainingContent = (htmlContent) => {
	const parsed = parseHtmlContent(htmlContent);
	if (!parsed) return false;
	
	const { tempDiv, firstP, firstDiv, parts } = parsed;
	
	if (firstP) {
		// Créer une copie pour ne pas modifier l'original
		const tempCopy = tempDiv.cloneNode(true);
		const firstPCopy = tempCopy.querySelector('p');
		firstPCopy.remove();
		return tempCopy.innerHTML.trim() !== '';
	}
	
	if (firstDiv) {
		const tempCopy = tempDiv.cloneNode(true);
		const firstDivCopy = tempCopy.querySelector('div');
		firstDivCopy.remove();
		return tempCopy.innerHTML.trim() !== '';
	}
	
	return parts.length > 1;
};

export default { getFirstParagraph, getRemainingContent, hasRemainingContent };